export default {
      id: "dazzle-star-propeller-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "img/icons.68fd9e19.svg#dazzle-star-propeller",
      toString: function () {
        return this.url;
      }
    }